// extracted by mini-css-extract-plugin
export default {"container":"for_3Ii_9"};